module.exports = __webpack_public_path__ + "static/img/14.27d771bb.png";